/* eslint-disable @typescript-eslint/no-namespace */
import { keyframes, type Keyframes as EmotionKeyframes } from '@emotion/react';

export namespace Keyframes {
  /** Keyframe Variant Keys */
  export type VariantKeys =
    | 'bounceIn'
    | 'fade'
    | 'fadeInOut'
    | 'hide'
    | 'loading'
    | 'progress'
    | 'slideToRight'
    | 'slideToLeft'
    | 'slideFromRight'
    | 'slideFromLeft'
    | 'spin';

  /** Keyframe Variants */
  export type Variants = { [Key in VariantKeys]: EmotionKeyframes };
}

export const bounceIn = keyframes({
  '0%': {
    transform: 'scale(0)',
  },
  '75%': {
    transform: 'scale(1.2)',
  },
  '100%': {
    transform: 'scale(1)',
  },
});

export const fade = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
});

export const fadeInOut = keyframes({
  '0%': {
    opacity: 0.15,
  },
  '50%': {
    opacity: 0.6,
  },
  '100%': {
    opacity: 0.15,
  },
});

export const loading = keyframes({
  '0%': {
    backgroundPosition: '-100%',
  },
  '100%': {
    backgroundPosition: '100%',
  },
});

export const progress = keyframes({
  '0%': {
    width: 0,
  },
  '100%': {
    width: '100%',
  },
});

export const slideFromRight = keyframes({
  '0%': {
    transform: 'translateX(100%)',
  },
  '100%': {
    transform: 'translateX(0%)',
  },
});

export const slideFromLeft = keyframes({
  '0%': {
    transform: 'translateX(-100%)',
  },
  '100%': {
    transform: 'translateX(0%)',
  },
});

export const slideToRight = keyframes({
  '0%': {
    transform: 'translateX(0%)',
  },
  '100%': {
    transform: 'translateX(100%)',
  },
});

export const slideToLeft = keyframes({
  '0%': {
    transform: 'translateX(0%)',
  },
  '100%': {
    transform: 'translateX(-100%)',
  },
});

export const spin = keyframes({
  '0%': {
    transform: 'rotate(0deg)',
  },
  '100%': {
    transform: 'rotate(360deg)',
  },
});

export const hide = keyframes({
  '0%': {
    maxWidth: '100vw',
    maxHeight: '100vh',
  },
  '100%': {
    maxWidth: '0',
    maxHeight: '0',
  },
});

const keyframe: Keyframes.Variants = {
  bounceIn,
  fade,
  fadeInOut,
  hide,
  loading,
  progress,
  slideToRight,
  slideToLeft,
  slideFromRight,
  slideFromLeft,
  spin,
};

export const keyframeVariants = Object.keys(keyframe) as Keyframes.VariantKeys[];

export default keyframe;
